import styles from './Immunization.module.css';

import { useState } from 'react';

import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';

import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';
import CheckboxAndData from '../../../components/CheckboxAndData/CheckboxAndData';
import { FaChevronDown, FaFileAlt } from 'react-icons/fa';
import { openModal } from '../../../redux/slices/modalSlice';
import { useDispatch } from 'react-redux';

function Immunization() {
  const dispatch = useDispatch();
  const [isExempteted, setIsExempted] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [selectedIds, setSelectedIds] = useState([]);

  const columnData = [
    {
      _id: 'row1',
      checkBox: <CheckboxAndData checkboxSize={20} />,
      vaccinationTitle: (
        <div className={styles.vaccinationTitleCell}>
          <div>Boostrix</div>
          <div
            className={styles.accountsOption}
            onClick={() => dispatch(openModal('addVaccinationNote'))}
          >
            <FaFileAlt size={14} color={'var(--Primary_Color)'} /> Accounts
          </div>
        </div>
      ),
      dose1: (
        <div className={styles.doseContainer}>
          <div className={styles.missingBox}>
            Missing <FaChevronDown size={12} />
          </div>
          <div className={styles.dateBox}>Due Date :21/04/25</div>
        </div>
      ),
      dose2: (
        <div className={styles.doseContainer}>
          <div className={styles.missingBox}>
            Missing <FaChevronDown size={12} />
          </div>
          <div className={styles.dateBox}>Due Date :21/04/25</div>
        </div>
      ),
      dose3: (
        <div className={styles.doseContainer}>
          <div className={styles.missingBox}>
            Missing <FaChevronDown size={12} />
          </div>
          <div className={styles.dateBox}>Due Date :21/04/25</div>
        </div>
      ),
    },
  ];

  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === columnData.length}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedIds(columnData.map((item) => item._id));
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Vaccination Title', accessor: 'vaccinationTitle' },
    { title: 'Dose#1', accessor: 'dose1' },
    { title: 'Dose#2', accessor: 'dose2' },
    { title: 'Dose#3', accessor: 'dose3' },
  ];
  return (
    <div className={styles.Immunization}>
      <div className={styles.header}>
        <ToggleSwitch
          checked={isExempteted}
          onChange={setIsExempted}
          labelColor={'var(--Grey_Color'}
          offLabel="Exempt student from all immunizations"
          onLabel="Exempt student from all immunizations"
        />
      </div>
      <div className={styles.body}>
        <div className={styles.tableWrapper}>
          <DynamicTable
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default Immunization;
